import Vue from 'vue';
import Router from 'vue-router';
import store from './store/store';
import Login from '@/views/Auth/Login.vue';
import NyGovCallback from '@/views/Auth/NyGovCallback.vue';

Vue.use(Router);

const router = new Router({
	mode: 'history',
	base: process.env.BASE_URL,
	scrollBehavior() {
		return { x: 0, y: 0 };
	},
	routes: [
		// Auth
		{
			path: '/Login',
			name: 'Login',
			component: Login,
		},
		{
			path: '/NyGovCallback',
			component: NyGovCallback
		},

		// Dashboard
		{
			path: '/',
			redirect: 'Dashboard',
			meta: {
				requiresAuth: true
			}
		},
		{
			path: '/Dashboard',
			name: 'Dashboard',
			component: () => import('@/views/Dashboard/DashboardView.vue'),
			meta: {
				requiresAuth: true
			}
		},

		// Interview
		{
			path: '/StartInterview',
			name: 'StartInterview',
			component: () => import('@/views/Interview/StartInterview.vue'),
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: '/Interview',
			name: 'Interview',
			component: () => import('@/views/Interview/Interview.vue'),
			children: [
				{
					path: 'Filing',
					name: 'Filing',
					component: () => import('@/views/Interview/FilingView.vue'),
					meta: {
						requiresAuth: true,
					},
				},
				{
					path: 'ClaimantProfile',
					name: 'ClaimantProfile',
					component: () => import('@/views/Interview/ClaimantProfileView.vue'),
					meta: {
						requiresAuth: true,
					},
				},
				{
					path: 'AgentToClaimant',
					name: 'AgentToClaimant',
					component: () => import('@/views/Interview/AgentToClaimantView.vue'),
					meta: {
						requiresAuth: true,
					},
				},
				{
					path: 'Deceased',
					name: 'Deceased',
					component: () => import('@/views/Interview/DeceasedView.vue'),
					meta: {
						requiresAuth: true,
					},
				},
				{
					path: 'Claim',
					name: 'Claim',
					component: () => import('@/views/Interview/ClaimView.vue'),
					meta: {
						requiresAuth: true,
					},
				},
				{
					path: 'Affirmation',
					name: 'Affirmation',
					component: () => import('@/views/Interview/AffirmationView.vue'),
					meta: {
						requiresAuth: true,
					},
				},
				{
					path: 'Summary',
					name: 'Summary',
					component: () => import('@/views/Interview/SummaryView.vue'),
					meta: {
						requiresAuth: true,
					},
				},
				{
					path: 'Payment',
					name: 'Payment',
					component: () => import('@/views/Interview/PaymentView.vue'),
					meta: {
						requiresAuth: true,
					},
				},
			]
		},
		{
			path: '/Confirmation',
			name: 'Confirmation',
			component: () => import('@/views/Interview/ConfirmationView.vue'),
			meta: {
				requiresAuth: true,
			},
		},
	]
});

router.beforeEach((to, from, next) => {
	const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
	const isLoggedIn = (store as any).getters['AuthModule/token'] != null;

	if (requiresAuth && !isLoggedIn) next('Login');
	else next();
})

export default router;
